import { Pressable, Text } from "native-base"
import { copyEvent } from "../../Navigator/TopNavigator/ExpandedMenu/utils"
import { webFont } from "../../Universal/API/API"

import React from "react"
import { useAppContext } from "../../Universal/API/Context-API/AppContext"
import { copyArt, show_toast } from "./utils"
import { DeanteData } from "../../Universal/API/Context-API/AppProvider"

const ArtButton:React.FC<{
    unit: DeanteData
}> = ({ unit } ) => {


    const { scaleAll } = useAppContext()

    return (
        <Pressable
            onPress={() => copyArt({art: unit.art})}
            style={{
                borderStyle: 'dashed',
                padding: scaleAll * (5), backgroundColor: 'rgba(255,255,255,0.4)', borderRadius: scaleAll * (8), borderWidth: 1
            }}>
            <Text color={'black'} fontFamily={webFont("Inter")} fontSize={12 * scaleAll}>
                {unit.art}
            </Text>
        </Pressable>
    )
}

export default React.memo(ArtButton)